<div class="fluid-container mt-3">
  <div class="row container-fluid mt-3" >
    <div class="col-lg-3 col-md-3 mb-3 d-flex flex-column">
      <app-list-candidates [showOnlyHiredCandidate]="false"></app-list-candidates>
    </div>
    <div class="col-12 col-md-9 col-lg-9">
      <div class="form-container">
        <div class="user-dashboard-info-box">
          <div class="section-title-02 mb-4">
            <div class="pl-0 pr-2 d-flex">
              <button class="btn btn-primary float-left" (click)="addMilestone()">
                New
              </button>
              <button class="btn btn-primary float-left" title="Refresh milestones" (click)="refreshMilestone()">
                <i class="fas fa-refresh p-0"></i>
              </button>
              <button class="btn btn-secondary float-right" [disabled]="!milestonesCompleted()"
                (click)="onFinishClicked()">
                Finish Job
              </button>
            </div>
            <div class="pl-0 pr-2 d-flex">
              <div class="row mt-2">
                <div class="col-5">
                  <h5 class="mt-3">Currency</h5>
                </div>
                <div class="col-7">
                  <select class="form-control basic-select" (change)="onCurrencyChange($event.target.value)">
                    <option *ngFor="let currency of lookupStore.currencies | async">{{currency.code}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <form [formGroup]="addMilestoneForm" class="needs-validation" novalidate>
            <ng-container>
              <div class="row">
                <div class="col-12">
                  <h5>Milestones</h5>
                </div>
              </div>
              <ng-container *ngFor="let milestone of milestonesFormArray.controls; let i = index">
                <div class="row mb-3" [formGroup]="milestone">
                  <div class="col-12 pr-0 mt-2">
                    <div class="form-row align-items-center">
                      <div class="col-md-2 action-div">
                        <p class="mb-0" *ngIf="!isNewMilestone(i)">
                          Progress: <b>{{ getStatusText(i) }}</b>
                        </p>
                      </div>
                      <div class="col-lg-3 col-sm-12 mt-2">
                        <input type="text" class="form-control" placeholder="Description including hours"
                          formControlName="description" required />
                        <small class="text-danger mt-1" *ngIf="isFormSubmitted">
                          {{ getValidationMessage("description", i) }}
                        </small>
                      </div>
                      <div class="col-lg-2 mt-2">
                        <label class="mb-0 ">
                          {{ getCurrencySymbol(i) }}
                          <input type="number" min="1" class="form-control pl-2 pr-2" placeholder="Amount"
                            formControlName="amount" />
                        </label>
                        <small class="text-danger mt-1" *ngIf="isFormSubmitted">
                          {{ getValidationMessage("amount", i) }}
                        </small>
                      </div>
                      <div class="col-lg-2 datetimepickers float-left mt-2">
                        <div class="input-group">
                          <input class="form-control" placeholder="start" name="dp" formControlName="startDate"
                            [minDate]="minStartDate" ngbDatepicker #startDate="ngbDatepicker" (dateSelect)="onStartDateSelect($event)" />
                          <div class="input-group-append" *ngIf="isNewMilestone(i)">
                            <button class="btn btn-outline-secondary calendar" (click)="startDate.toggle()"
                              type="button"></button>
                          </div>
                        </div>
                        <small class="text-danger mt-1" *ngIf="isFormSubmitted">
                          {{ getValidationMessage("startDate", i) }}
                        </small>
                      </div>
                      <div class="col-lg-2 datetimepickers float-left mt-2">
                        <div class="input-group">
                          <input class="form-control" placeholder="end" name="dp" formControlName="endDate"
                            ngbDatepicker #endDate="ngbDatepicker" [minDate]="minEndDate" />
                          <div class="input-group-append" *ngIf="isNewMilestone(i)">
                            <button class="btn btn-outline-secondary calendar" (click)="endDate.toggle()"
                              type="button"></button>
                          </div>
                        </div>
                        <small class="text-danger mt-1" *ngIf="isFormSubmitted">
                          {{ getValidationMessage("endDate", i) }}
                        </small>
                      </div>
                      <div class="col-lg-2 col-md-4 action-div mt-2">
                        <button class="btn btn-danger" title="Delete milestone" *ngIf="canDeleteMilestone(i)"
                          (click)="removeMilestone(i)">
                          Delete
                        </button>
                        <button class="btn btn-success" title="Payout milestone amount" *ngIf="showPayout(i)"
                          (click)="handleMilestonePayout(i)">
                          Pay Now
                        </button>
                        <button class="btn" ngClass="btn-success" title="Release Payment" *ngIf="isProgressDone(i)"
                          (click)="handleMilestoneStatusChangeEvent(i)">
                          Release Payment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary float-right" (click)="saveMilestones()">
                    Save
                  </button>
                </div>
              </div>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal #paymentModal [modalConfig]="modalConfig">
  <div class="form-row d-flex">
    <div class="col-md-8 offset-md-2">
      <div class="row">
        <div *ngIf="totalAmount" class="col-12">
          <h5>Amount to pay now: {{ currencySymbol }}{{ totalAmount }}</h5>
        </div>
        <div *ngIf="paymentFailed" class="col-12">
          <h5>Your payment is failed to process. Please try again.</h5>
        </div>
      </div>
      <div class="row">
        <div *ngIf="!paymentProcessed" class="col-12">
          <ngx-paypal [config]="payPalConfig"></ngx-paypal>
        </div>
        <div *ngIf="paymentProcessed" class="col-12">
          <h5>Your payment is successfully processed.</h5>
        </div>
      </div>
    </div>
  </div>
</app-modal>
<app-modal #confirmationModal [modalConfig]="confirmationModalConfig">
  <div>Are you sure to delete this milestone.</div>
</app-modal>
<app-modal #releasePaymentConfirmationModal [modalConfig]="confirmationModalConfig">
  <div>Are you sure to request to release payment.</div>
</app-modal>